import React from "react";

type Crumb = {
  label: string;
  href: string;
};

type BreadcrumbNavProps = {
  items: Crumb[];
};

export default function BreadcrumbNav({ items }: BreadcrumbNavProps) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-slate-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.href}-${item.label}`} className="inline-flex items-center gap-2">
              {isLast ? (
                <span className="text-indigo-600 font-medium" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <a href={item.href} className="hover:text-slate-700 transition-colors duration-200">
                  {item.label}
                </a>
              )}
              {!isLast ? <span aria-hidden="true">/</span> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
